module.exports = "<p>\r\n  add-question-step-popup works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/add-question-step-popup/add-question-step-popup.component.html
// module id = ../../../../../src/app/content-page/admin/create-operating-standard/opst-step-eight/add-question-step-popup/add-question-step-popup.component.html
// module chunks = main